import _extends from "@babel/runtime/helpers/extends";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Icon, { ICON_SIZE_12, ICON_SIZE_16, ICON_SIZE_24, ICON_SIZE_32 } from '../Icon';

/**
 * `Heading` is used as a text title (or a subtitle) to define the hierarchy and the structure of the content.
 * @since 2.3.0
 */
const Heading = ({
  baseClassName = "".concat(CLS_PREFIX, "heading"),
  className,
  icon,
  children,
  component: Tag,
  level = 1,
  ...props
}) => {
  if (!Tag) {
    Tag = "h".concat(level);
  }

  let iconSize = ICON_SIZE_16;

  if (level === 1) {
    iconSize = ICON_SIZE_32;
  }

  if (level === 2 || level === 3) {
    iconSize = ICON_SIZE_24;
  }

  if (level === 6) {
    iconSize = ICON_SIZE_12;
  }

  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: classNames(baseClassName, {
      ["".concat(baseClassName, "--h").concat(level)]: level,
      ["".concat(baseClassName, "--icon")]: icon
    }, className)
  }, props), Icon.create(icon, {
    className: "".concat(baseClassName, "__icon"),
    size: iconSize
  }), icon ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(baseClassName, "__text")
  }, children) : children);
};

export default Heading;